import { render, staticRenderFns } from "./DialogAlert.vue?vue&type=template&id=797078ad"
import script from "./DialogAlert.vue?vue&type=script&lang=js"
export * from "./DialogAlert.vue?vue&type=script&lang=js"
import style0 from "./DialogAlert.vue?vue&type=style&index=0&id=797078ad&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('797078ad')) {
      api.createRecord('797078ad', component.options)
    } else {
      api.reload('797078ad', component.options)
    }
    module.hot.accept("./DialogAlert.vue?vue&type=template&id=797078ad", function () {
      api.rerender('797078ad', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/ui/components/DialogAlert.vue"
export default component.exports